var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16.75,
    viewBox: "0 0 19 16.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -1.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 1.5,
    transform: "translate(0 16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 1.5,
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8,
    height: 1.5,
    transform: "translate(10 7.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8,
    height: 1.5,
    transform: "translate(3.75 1.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8,
    height: 1.5,
    transform: "translate(10 3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8,
    height: 1.5,
    transform: "translate(-1 4.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueue);
export default __webpack_public_path__ + "static/media/Queue.67a6fb31.svg";
export { ForwardRef as ReactComponent };